(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  // Add line items via AJAX and open the cart drawer / notification.
  window.IdyllCart = {
    add: function (items) {
      var cart = getCart();
      var sections = [];
      if (cart && typeof cart.getSectionsToRender === 'function') {
        sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      }
      var body = {
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      };
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response && response.status) {
            // Shopify error (e.g. sold out) — surface nothing, leave page as-is
            return response;
          }
          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList) cart.classList.remove('is-empty');
            cart.renderContents(response); // updates sections AND opens the drawer
          } else {
            window.location = root() + 'cart';
          }
          return response;
        })
        .catch(function () {
          window.location = root() + 'cart';
        });
    }
  };

  // Delegated handler for one-click "Add" buttons (e.g. cart drawer upsells).
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cart-add]') : null;
    if (!btn) return;
    var id = btn.getAttribute('data-cart-add');
    if (!id) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    window.IdyllCart.add([{ id: id, quantity: 1 }]).then(function () {
      btn.removeAttribute('aria-busy');
    });
  });

  // Delegated handler for simple single-product forms opting in with data-ajax-cart.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.matches !== 'function' || !form.matches('form[data-ajax-cart]')) return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;
    e.preventDefault();
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    window.IdyllCart.add([{ id: idInput.value, quantity: qty }]).then(function () {
      if (btn) btn.removeAttribute('aria-busy');
    });
  });
})();
